"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.moment = void 0;
var m = require('moment');
var ru = require('moment/locale/ru');
m.locale('ru');
exports.moment = m;
